<template>
  <v-dialog v-model="show" persistent max-width="680" scrollable>
    <v-card>
      <v-card-title class="text-h6 pa-4">Termeni și Condiții</v-card-title>
      <v-divider />
      <v-card-text style="max-height: 60vh;">
        <div v-if="loading" class="d-flex justify-center py-8">
          <v-progress-circular indeterminate color="primary" />
        </div>
        <div v-else v-html="termsHtml" class="terms-content" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn variant="text" color="error" @click="$emit('declined')">
          Refuz
        </v-btn>
        <v-spacer />
        <v-btn color="primary" variant="flat" :loading="accepting" @click="accept">
          Accept termenii
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import apiService from '@/services/ApiService.js'

export default {
  name: 'TermsModal',

  // @param modelValue {Boolean} - controls dialog visibility
  // @emits accepted - fired after successful ToS acceptance, no payload
  emits: ['accepted', 'declined'],

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      termsHtml: '',
      loading: true,
      accepting: false,
    }
  },

  computed: {
    show: {
      get() { return this.modelValue },
      set(val) { this.$emit('update:modelValue', val) },
    },
  },

  watch: {
    modelValue(val) {
      if (val && !this.termsHtml) this.fetchTerms()
    },
  },

  methods: {
    async fetchTerms() {
      this.loading = true
      try {
        const backendBase = process.env.VUE_APP_API_ENDPOINT.replace('/api', '')
        const res = await fetch(`${backendBase}/terms-content`)
        this.termsHtml = await res.text()
      } catch {
        this.termsHtml = '<p>Nu s-a putut încărca conținutul. Te rugăm să reîncerci.</p>'
      } finally {
        this.loading = false
      }
    },


    async accept() {
      this.accepting = true
      try {
        await apiService.request('/auth/accept-terms', { method: 'POST' })
        this.$emit('accepted')
      } finally {
        this.accepting = false
      }
    },
  },
}
</script>

<style scoped>
.terms-content :deep(h4) {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  font-weight: 600;
}
.terms-content :deep(p),
.terms-content :deep(ul) {
  font-size: 0.875rem;
  color: rgba(var(--v-theme-on-surface), 0.8);
}
.terms-content :deep(li) {
  margin-bottom: 0.35rem;
}
</style>
